import React from 'react';

const PMS = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M16.307 11.594a1.97 1.97 0 01-1.983-2.003L14.437 3 4.678 5.32C2.977 5.804 2.03 6.461 2 8.2l.064 18.938c-.03 1.738.964 2.585 2.568 2.947l15.117 2.253c1.749 0 3.197-1.414 3.227-3.15l.31-17.59h-6.98v-.004zM6.89 23.284l2.615.342c.48 0 .857.384.849.86a.88.88 0 01-.88.86l-2.615-.34a.842.842 0 01-.848-.861.875.875 0 01.879-.86zm-.803-3.382a.88.88 0 01.88-.86h11.108a.84.84 0 01.85.86.88.88 0 01-.88.86H6.942a.852.852 0 01-.853-.86h-.001zm12.07-5.443c.48 0 .856.383.848.86a.88.88 0 01-.879.86l-11.11.409a.843.843 0 01-.848-.86.88.88 0 01.878-.86l11.11-.41z"
            fill="#007AFF"
        />
        <path
            d="M16.052 9.587a.28.28 0 00.284.287h6.592a3.063 3.063 0 00-.594-.789L16.867 3.86c-.21-.2-.448-.37-.705-.506l-.11 6.233z"
            fill="#FF6961"
        />
        <path
            d="M26.974 30.39h-3.052V18.463h5.124v9.868a2.068 2.068 0 01-2.072 2.057z"
            fill="#60B158"
        />
        <path
            d="M28.392 14.259a2.607 2.607 0 01-2.614 2.599 2.623 2.623 0 01-1.906-.818v-3.556a2.61 2.61 0 011.906-.822 2.602 2.602 0 012.615 2.598l-.001-.001z"
            fill="#FFA700"
        />
        <path
            d="M31.929 28.17h-2.093v-9.69H34v7.633a2.065 2.065 0 01-2.071 2.059v-.001z"
            fill="#60B158"
        />
        <path
            d="M33.465 15.06a2.12 2.12 0 01-2.126 2.113 2.126 2.126 0 01-1.55-.666v-2.89a2.129 2.129 0 011.55-.666 2.116 2.116 0 012.126 2.11z"
            fill="#FFA700"
        />
    </svg>
);

export default PMS;